import placehoder from '/images/banner_placeholder.webp'
import { Badge } from '@chakra-ui/react/badge'
import { Box } from '@chakra-ui/react/box'
import { Button } from '@chakra-ui/react/button'
import { Flex } from '@chakra-ui/react/flex'
import { HStack, Stack } from '@chakra-ui/react/stack'
import { Text } from '@chakra-ui/react/text'
import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import PointsIcon from '@/icons/PointsIcon'
import WarningIcon from '@/icons/WarningIcon'
import { DATA_PROCESSING_PDF_URL, RULES_PDF_URL } from '@/pages/Esum/constants'
import { esumStore } from '@/pages/Esum/esumStore'
import { FetchState } from '@/types/enum'

import classes from './styles.module.css'

import { ConditionsAccordion } from '../ConditionsAccordion'
import { ExternalLink } from '../ExternalLink'
import { SkeletonImage } from '../SkeletonImage'
import { TimerBlock } from '../TimerBlock'

export const OfferCard = observer(() => {
  const { offer, isActivated, isActivating, isExpired, activateState } =
    esumStore

  if (!offer) return null

  const renderAction = () => {
    if (isExpired) {
      return (
        <Button disabled className={classes.expiredBtn}>
          Задание недоступно
        </Button>
      )
    }

    if (isActivated) {
      return <TimerBlock />
    }

    return (
      <>
        <Button
          disabled={isActivating}
          onClick={() => esumStore.activate()}
          className={classes.activateBtn}
        >
          Активировать
        </Button>
        <Text className={classes.legal}>
          Нажимая кнопку «Активировать», я принимаю{' '}
          <ExternalLink href={RULES_PDF_URL} className={classes.legalLink}>
            Правила Акции
          </ExternalLink>
          . Обработка данных осуществляется в порядке, предусмотренном{' '}
          <ExternalLink
            href={DATA_PROCESSING_PDF_URL}
            className={classes.legalLink}
          >
            Политикой в отношении обработки данных
          </ExternalLink>
        </Text>
      </>
    )
  }

  return (
    <Box className={classes.cardContainer}>
      <Box className={classes.card}>
        <SkeletonImage
          src={placehoder}
          alt={offer.heading}
          className={classes.image}
        />

        <Stack className={classes.stack}>
          <Flex className={classes.rewardRow}>
            <Text className={classes.rewardTitle}>Ваша награда</Text>
            <Badge
              className={clsx(classes.badge, {
                [classes.badgeDisabled]: isExpired,
              })}
              aria-label="1000 баллов"
            >
              <Text className={classes.badgePoints}>+{offer.text}</Text>
              <PointsIcon className={classes.badgeIcon} />
            </Badge>
          </Flex>

          <Box className={classes.taskBlock}>
            <Stack className={classes.taskStack}>
              <Text className={classes.taskLabel} as="h2">
                Задание:
              </Text>
              <Text className={classes.taskText}>
                Совершите покупку на сумму от{' '}
                <Text as="span" className={classes.taskTextBold}>
                  {offer.subheading}
                  {'\u00A0'}₽
                </Text>{' '}
                (товары исключения смотрите в условиях акции)
              </Text>
            </Stack>
          </Box>

          {renderAction()}

          {activateState === FetchState.rejected && (
            <Box className={classes.errorBanner} role="alert">
              <HStack className={classes.errorRow}>
                <Flex className={classes.errorIconWrapper}>
                  <WarningIcon color="#D82A13" className={classes.errorIcon} />
                </Flex>
                <Text className={classes.errorText}>
                  Не удалось получить данные. Попробуйте ещё раз
                </Text>
              </HStack>
            </Box>
          )}

          <ConditionsAccordion disabled={isExpired} />

          {!isActivated && (
            <Text className={classes.warning}>
              Внимание! Задание нужно будет выполнить в течение 60 минут после
              активации.
            </Text>
          )}
        </Stack>
      </Box>
    </Box>
  )
})
